import { FieldSet, Record } from "airtable"
import { useEffect, useMemo, useState } from "react"
import { CMSQueryInfoCards } from "service/airtable"

const NOTE_KEY = "Name"
const NOTE_VALUE_POOL_INFO = "Pool Info"

export function useCMSNotes() {
    const [record, setRecord] = useState<Record<FieldSet>>()
    useEffect(() => {
        CMSQueryInfoCards.eachPage(
            records => {
                const record = records.find(record => record.get(NOTE_KEY) === NOTE_VALUE_POOL_INFO)
                setRecord(record)
            },
            (err: any) => {
                if (err) {
                    console.error(`[Airtable] ${err}`)
                    return
                }
            },
        )
    }, [])

    return useMemo(() => {
        if (!record) {
            return
        }

        return {
            title: record.get("Title"),
            description: record.get("Description"),
            ctaText: record.get("CTA Text"),
            ctaLink: record.get("CTA URL"),
        }
    }, [record])
}
